/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	MetaAdStructureFacebookDetailsPathParams,
	MetaAdStructureFacebookDetailsResponse,
} from '../types/MetaAdStructureFacebookDetails'

/**
 * GET /meta/ad-campaign/:metaAdCampaign/facebook-details
 * @see backend/nexus/modules/MetaAd/Http/Controllers/MetaAdStructureController.php MetaAdStructureController::facebookDetails
 */
export async function metaAdStructureFacebookDetails(
	metaAdCampaign: MetaAdStructureFacebookDetailsPathParams['metaAdCampaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MetaAdStructureFacebookDetailsResponse>> {
	return axiosInstance.get(`/meta/ad-campaign/${metaAdCampaign}/facebook-details`, config)
}
